/* Black Friday 2026 landing page: finale countdown, quick add / package add to the native Shopify cart,
   teaser waiting-list form (Klaviyo client API; sending OFF until the section setting is ticked).
   Shopify owns prices and the automatic discounts; this script only composes the cart. */
(function () {
  'use strict';
  var CFG = window.IPBF || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---- countdown (finale) ---- */
  document.querySelectorAll('[data-bf-countdown]').forEach(function (el) {
    var end = Number(el.getAttribute('data-end')) * 1000;
    if (!end) return;
    var units = { d: el.querySelector('[data-unit="d"]'), h: el.querySelector('[data-unit="h"]'), m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0) { el.textContent = el.getAttribute('data-ended') || ''; return; }
      units.d.textContent = Math.floor(left / 86400);
      units.h.textContent = pad(Math.floor((left % 86400) / 3600));
      units.m.textContent = pad(Math.floor((left % 3600) / 60));
      units.s.textContent = pad(left % 60);
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  });

  /* ---- cart ---- */
  function request(path, body) {
    return fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ('cart ' + r.status)); return j; }); });
  }
  function updateCount(cart) {
    document.querySelectorAll('.ip-pdp-cart-count, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
  }
  var toast;
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'ipbf-toast'; toast.setAttribute('role', 'status');
      toast.innerHTML = '<span></span><a href="' + root + 'cart“>Add to cart <i class="ph ph-arrow-right" aria-hidden="true"></i></a>';
      (document.querySelector('.ipbf') || document.body).appendChild(toast);
    }
    toast.querySelector('span').textContent = msg; toast.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.hidden = true; }, 6000);
  }
  document.querySelectorAll('[data-bf-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var items;
      try { items = JSON.parse(btn.getAttribute('data-items')); } catch (e) { return; }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      request('cart/add.js', { items: items })
        .then(function () {
          /* Code mode (Stefan 2026-10-26): the code is applied to the cart right here, so the cart page already shows the
             discounted lines, the free-shipping gap and the gift progress — no retyping at the checkout. Shopify owns
             the maths; if the code cannot be applied the cart just stays at regular prices and the cart page offers it again. */
          if (CFG.mode === 'code' && CFG.code) return request('cart/update.js', { discount: CFG.code }).catch(function () { return request('cart.js'); });
          return request('cart.js');
        })
        .then(function (cart) {
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('iprobio:bf_add', { items: items, source: 'black-friday-page', code: CFG.code || null }); } catch (e) {}
          updateCount(cart);
          btn.classList.add('is-done');
          var lbl = btn.querySelector('.ipbf-add-label'), done = btn.querySelector('.ipbf-add-done');
          if (lbl && done) { lbl.hidden = true; done.hidden = false; }
          showToast(items.length > 1 || items[0].quantity > 1 ? 'The bundle is in your cart' : 'Added to cart');
          setTimeout(function () { btn.classList.remove('is-done'); if (lbl && done) { lbl.hidden = false; done.hidden = true; } btn.disabled = false; btn.removeAttribute('aria-busy'); }, 2600);
        })
        .catch(function (err) {
          console.error('[bf] cart', err);
          showToast('It could not be added to the cart. Please try again.');
          btn.disabled = false; btn.removeAttribute('aria-busy');
        });
    });
  });

  /* ---- teaser form ---- */
  var form = document.getElementById('ipbf-form');
  if (!form) return;
  var email = document.getElementById('ipbf-email'), consent = document.getElementById('ipbf-consent');
  var btn = document.getElementById('ipbf-submit'), fail = document.getElementById('ipbf-fail'), done = document.getElementById('ipbf-done');
  var SOURCE = 'www.iprobio.sk/pages/black-friday';
  function setErr(id, input, msg) {
    var el = document.getElementById(id); el.textContent = msg || ''; el.hidden = !msg;
    if (input) { if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  email.addEventListener('input', function () { setErr('ipbf-email-err', email, ''); });
  consent.addEventListener('change', function () { setErr('ipbf-consent-err', null, ''); });
  function utm() {
    var q = new URLSearchParams(location.search), o = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (q.get(k)) o[k] = q.get(k); });
    return o;
  }
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(CFG.key), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r; });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    fail.hidden = true;
    var em = email.value.trim(), ok = true;
    if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { setErr('ipbf-email-err', email, 'Please check your e-mail address.'); ok = false; }
    if (!consent.checked) { setErr('ipbf-consent-err', null, 'Without your consent we cannot send you the offer.'); ok = false; }
    if (!ok) { (email.getAttribute('aria-invalid') ? email : consent).focus(); return; }
    var props = Object.assign({ lead_source_url: SOURCE, campaign: 'black-friday-2026', page: location.pathname }, utm());
    var event = { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: 'Black Friday list' } } },
      profile: { data: { type: 'profile', attributes: { email: em, properties: { bf2026_waitlist: true, lead_source_url: SOURCE } } } },
      unique_id: 'bf2026:' + em.toLowerCase()
    } } };
    var sub = CFG.list ? { data: { type: 'subscription', attributes: {
      custom_source: 'Black Friday 2026 list',
      profile: { data: { type: 'profile', attributes: { email: em, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: CFG.list } } } } } : null;
    btn.disabled = true; btn.textContent = 'Zapisujeme…';
    var run;
    if (CFG.send && CFG.key) {
      run = Promise.all([post('events', event), sub ? post('subscriptions', sub) : null]);
    } else {
      console.info('[bf] sending OFF (theme editor → send_enabled). Payload:', { event: event, subscription: sub });
      run = Promise.resolve();
    }
    run.then(function () {
      document.getElementById('ipbf-done-email').textContent = em;
      form.hidden = true; done.hidden = false; done.focus();
    }).catch(function (err) {
      console.error('[bf]', err);
      fail.hidden = false; btn.disabled = false; btn.textContent = 'I want to be the first to know';
    });
  });
})();
